import {postRequest, formDataRequest, getRequest} from '../libs/AxiosService.util';
import Constants from "../config/constants";

export async function serviceCreateDoctorRequest(params) {
    return await postRequest('roles/create', params);
}

export async function serviceUpdateDoctorRequest(params) {
    return await formDataRequest('roles/update', params);
}

export async function serviceDeleteDoctorRequest(params) {
    return await postRequest('roles/delete', params);
}

export async function serviceDoctorRequestDetail(params) {
    return await postRequest('doctors/details', params, Constants.DOCTOR_APP_API_URL);
}
export async function serviceDetailPermissions(params) {
    return await formDataRequest('roles/permissions', params);
}

export async function serviceGetDoctorRequest (params) {
    return await postRequest('doctors', params, Constants.DOCTOR_APP_API_URL);
}

export async function serviceDoctorUpdateStatus (params) {
    return await postRequest('doctors/update/overall/status', params, Constants.DOCTOR_APP_API_URL);
}
export async function serviceUpdateKycStatus (params) {
    return await postRequest('doctors/update/kyc/status', params, Constants.DOCTOR_APP_API_URL);
}
export async function serviceGetDoctorCount (params) {
    return await getRequest('doctors/counts', params, Constants.DOCTOR_APP_API_URL);
}
